import { render, staticRenderFns } from "./close.vue?vue&type=template&id=2ea03326&functional=true&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"
import style0 from "./close.vue?vue&type=style&index=0&id=2ea03326&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports